const initialState = {
    isOpen: false,
    type: '',
    data: {}
}

export const modals = {
    state: initialState,
    reducers: {
        setOpen: (s, payload) => {
            return {
                ...s,
                isOpen: payload.open,
                type: payload.type || '',
                data: payload.data || {}
            }
        },

        /**
         * Reset modal
         * 
         * @param {*} s 
         * @param {*} payload 
         * @returns 
         */
        reset: (s) => {
            return {
                ...s,
                isOpen: false,
                type: ''
            }
        }
    },
    effects: (dispatch) => ({

        /**
         * Open new Modal
         * 
         * @param {*} payload 
         */
        onModalRequest(payload) {
            this.setOpen(payload)
        },

        /**
         * Reset Modal
         * 
         */
        onResetModal() {
            this.reset()

        }
    })
}